import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../../config/firebase-config';

// Redux
import { connect } from 'react-redux';

// Actions
import { signInWithGoogle } from '../../actions/authActions';
import { setAlert } from '../../actions/alertActions';

// Imgs
import google_logo from '../../util/imgs/google_logo.jpg';

const GoogleBtn = ({
    signInWithGoogle,
    setAlert,
    auth: {
        account_loading
    }
}) => {

    const [googleProcessing, setGoogleProcessing] = useState(false);

    const handleGoogleSignIn = () => {
        if(account_loading || googleProcessing) return;

        console.log('STARTING GOOGLE SIGN IN');

        setGoogleProcessing(true);
        
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider).then(async (result) => {

            const {
                email,
                emailVerified
            } = result.user;

            signInWithGoogle(
                result, 
                {
                    email,
                    emailVerified
                }
            )
        }).catch((e) => {
            setAlert('Problem with Google. Try Again.')
            setGoogleProcessing(false);
            console.log('ERROR SIGNING IN WITH GOOGLE')
            // console.error(e); // "oh, no!"
        })
    }

    return (
        <div onClick={handleGoogleSignIn} className='delivery_widget authPage grey_background'>
            <div style={{height: '70%', margin: '5px', padding: '3px', borderRadius: '50%', border: 'none', boxSizing: 'border-box'}}>
                <img style={{objectFit: 'cover', height: '100%'}} src={google_logo} />
            </div>

            <span style={{fontWeight: 'bold', fontSize: '16px', color: '#fff'}}>
                {googleProcessing ? 'Processing...' : 'Google'}
            </span>
            
        </div>
    )
}

GoogleBtn.propTypes = {
    signInWithGoogle: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component
    signInWithGoogle,
    setAlert
})(GoogleBtn);